(() => {
  const update = cart => {
    if (!cart || typeof cart.item_count !== 'number') return;

    const count = document.getElementById('cart-title-count');
    const label = document.getElementById('cart-title-label');

    if (!count || !label) return;

    count.textContent = cart.item_count;
    label.textContent = cart.item_count === 1 ? ' item' : ' items';
  };

  const isCartRequest = url =>
    /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url));

  const nativeFetch = window.fetch;

  window.fetch = function (...args) {
    return nativeFetch.apply(this, args).then(response => {
      const url = args[0] instanceof Request
        ? args[0].url
        : args[0];

      if (isCartRequest(url)) {
        response
          .clone()
          .json()
          .then(update)
          .catch(() => {});
      }

      return response;
    });
  };

  const nativeOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartRequest(url)) {
      this.addEventListener('load', function () {
        try {
          update(JSON.parse(this.responseText));
        } catch (error) {}
      });
    }

    return nativeOpen.apply(this, arguments);
  };
})();